import { useState, useEffect } from 'react';
import { useGet } from 'components';
import env from 'env';
import { useStore } from 'store';

export function MenuLoader() {
  const { state, dispatch } = useStore();
  const [loadingStatus, setLoadingStatus] = useState('ready');
  const [data, setData] = useState(null);

  const get = useGet();

  useEffect(() => {
    if (loadingStatus !== 'ready') return;
    if (state && !state.menu) {
      setLoadingStatus('loading');
      get.send(env.apiBase + "/api/cms/GetMenu");
    }
    // eslint-disable-next-line
  }, [state]);

  useEffect(() => {
    // console.log(data)
    if (data) {
      dispatch({ type: 'SET_MENU', payload: data.menu })
    }
    // eslint-disable-next-line
  }, [data]);

  if (loadingStatus !== 'done' && get.done()) {
    setLoadingStatus('done');
    setData(get.response);
  }
  return null;
}